module.exports = __webpack_public_path__ + "static/assets/5ae26aa80ec6d5f2e99aa90ee1a3a5cd.png";